import * as PIXI from "pixi.js";
import { ControlConstants } from "../../control/constant/ControlConstants";
import { TextFieldProperties } from "../../control/properties/TextFieldProperties";
import { CommonLang } from "../lang/CommonLang";
import { CommonFontStyle } from "../style/CommonFontStyle";
import { AbstractViewProperties } from "./AbstractViewProperties";
/*
 * SGDSignpostingProperties.ts
 */
export class SGDSignpostingProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.messageTitleProperties.equals(other.messageTitleProperties) &&
            this.messageBodyProperties.equals(other.messageBodyProperties);
    }
    setDefaultValues() {
        this.messageTitleProperties = new TextFieldProperties(CommonFontStyle.SIGNPOSTING_TITLE, null, null, ControlConstants.CENTER);
        this.messageBodyProperties = new TextFieldProperties(CommonFontStyle.SIGNPOSTING_BODY, null, CommonLang.SIGNPOSTING_GIBRALTAR, ControlConstants.CENTER, ControlConstants.CENTER);
        this.messageBodyProperties.multiline = true;
    }
}
export class SGDSignpostingLandscapeProperties extends SGDSignpostingProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.messageTitleProperties.position = new PIXI.Point(1218, 240);
        this.messageTitleProperties.size = new PIXI.Point(1000, 160);
        this.messageBodyProperties.position = new PIXI.Point(1218, 400);
        this.messageBodyProperties.size = new PIXI.Point(1300, 600);
    }
}
export class SGDSignpostingPortraitProperties extends SGDSignpostingProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.messageTitleProperties.position = new PIXI.Point(640, 580);
        this.messageTitleProperties.size = new PIXI.Point(1000, 160);
        this.messageBodyProperties.position = new PIXI.Point(640, 800);
        this.messageBodyProperties.size = new PIXI.Point(1000, 900);
    }
}
//# sourceMappingURL=SGDSignpostingProperties.js.map